var map = {
	"./evaluate/uk-UA.json": [
		63804,
		3804
	],
	"./explore/uk-UA.json": [
		54242,
		4242
	],
	"./explore_backoffice/uk-UA.json": [
		86672,
		6672
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87368;
module.exports = webpackAsyncContext;